import React,{useState,useRef,useEffect} from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import {Button,FormControlLabel,Checkbox,FormGroup,FormControl} from '@material-ui/core'
import Modal from '../../components/modal'
import './style.css'
import HeadPage from '../../components/header/without_logo'
import HTMLFlipBook from "react-pageflip";
import {useSpring, animated} from 'react-spring'
import {data,toc} from './data'
import {chunk} from 'lodash'
import {catalougeDownload} from '../../redux/action/catalouge'
import {useDispatch} from 'react-redux'
import Loading from '../../components/Loading'
import {isMobile} from 'react-device-detect'
import ChevronRight from '../../assets/image/chevron-right-white.svg'
import ChevronLeft from '../../assets/image/chevron-left-white.svg'
import MenuIcon from '@material-ui/icons/Menu';
import CatalogeDownload from '../../assets/image/catalouge-download.svg'
import CloseIcon from '@material-ui/icons/Close';
export default function Index() {
    const dispatch = useDispatch()
    const [modal, setmodal] = useState(false)
    const [modal2, setmodal2] = useState(false)
    const [open, setopen] = useState(false)
    const [active, setactive] = useState(0)
    const [range_thumbnail, setrange] = useState({
        start:0,
        end:open?6:7
    })
    const [range, setranges] = useState([])
    const [chunks, setchunks] = useState(chunk(data,7))
    const [active_chunks, setactive_chunks] = useState(0)
    const [active_toc, setactive_toc] = useState('')
    const [section, setsection] = useState({
        all_section:true,
        foreword:false,
        pathway_public_workshop:false,
        calendar:false,
        pathway_hr_academy:false,
        event_management:false,
        coming_soon_event:false,
    })
    useEffect(() => {
        // if(!isMobile){
            // ref.pageFlip.turnToPage(active)
        // }
        setchunks(chunk(data,isMobile?4:open?6:7))
    }, [open,active])
    let ref = useRef(null)
    let {all_section,foreword,pathway_public_workshop,calendar,pathway_hr_academy,event_management,coming_soon_event}=section
    const downloadSection=()=>{
        let slug=`?${all_section?'sections=1':''}${foreword?'&sections=2':''}${pathway_public_workshop?'&sections=3':''}${calendar?'&sections=4':''}${pathway_hr_academy?'&sections=5':''}${event_management?'&sections=6':''}${coming_soon_event?'&sections=7':''}`
        dispatch(catalougeDownload(slug))
    }
    const children=()=>{
        return(
            <div>
                <p className='semi-bold'>Select the section you want to download</p>
                <FormControl component="fieldset" >
                <FormGroup >
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.all_section} onChange={()=>setsection({...section,all_section:!section.all_section})} name="" />}
                        label="All Sections"
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.foreword} onChange={()=>setsection({...section,foreword:!section.foreword})} name="" />}
                        label="Foreword"
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.pathway_public_workshop} onChange={()=>setsection({...section,pathway_public_workshop:!section.pathway_public_workshop})} name="" />}
                        label="Pathway Public Workshop"
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.calendar} onChange={()=>setsection({...section,calendar:!section.calendar})} name="" />}
                        label="Calendar"
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.pathway_hr_academy} onChange={()=>setsection({...section,pathway_hr_academy:!section.pathway_hr_academy})} name="" />}
                        label="Pathway HR Academy"
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.event_management} onChange={()=>setsection({...section,event_management:!section.event_management})} name="" />}
                        label="Event Management"
                    />
                    <FormControlLabel
                        control={<Checkbox color='primary' checked={section.coming_soon_event} onChange={()=>setsection({...section,coming_soon_event:!section.coming_soon_event})} name="" />}
                        label="Coming Soon Events"
                    />
                </FormGroup>
            </FormControl>
            <br/>
            <Button onClick={()=>downloadSection()} className='btn-remove-capital' variant="contained" color="primary">Download</Button>
            </div>
        )
    }
    const tocModal=()=>{
        return(
            <div>
                {toc.map((data,i)=>(
                    <div className={`toc-modal ${active_toc===data.text&&'toc-active'}`} onClick={()=>onClickToc(data.page,data.text)} key={i}>
                        <div className='toc-title'>
                            <p >{data.text}</p>
                        </div>
                    </div>
                ))}
                <br/>
                <Button onClick={()=>setmodal(true)} className='btn-remove-capital' variant="contained" color="primary">Download</Button>
                <br/>
            </div>
        )
    }
    const tocProps = useSpring({width:open?285:100,top:open?200:140})
    const flipbookProps = useSpring({width:!open?'98%':'82%'})
    const toggle=()=>{
        setopen(!open)
    }
    const goToPage=(index)=>{
        ref.pageFlip.flip(index,10)
    }
    const nextPage=()=>{
        setactive_chunks(active_chunks+1)
        // setactive(chunks[active_chunks+1][0].page)
    }
    const prevPage=()=>{
        setactive_chunks(active_chunks-1)
        // setactive(chunks[active_chunks-1][0].page)
    }
    const onFlip=(i)=>{
        
        setactive(i.data)
        let filter=chunks.filter((data)=>{
            let find=data.find(f=>f['page']===i.data+1)
            if(find!==undefined){
                return true
            }else{
                return false
            }
        })
        let index=chunks.indexOf(filter[0])
        if(index>=0){
            setactive_chunks(index)

        }
       
    }
    const renderActiveThumb=(i)=>{
        if(active==i){
            return 'active-thumbnail'
        }
    }
    const renderBtnPrev=()=>{
        if(active_chunks!==0){
            if(isMobile){
                return <Button style={{minWidth:0,width:10}} onClick={()=>prevPage()} className='btn-remove-capital btn-chevron' variant="contained" color="primary">
                    <img src={ChevronLeft} style={{width:15}}/>
                </Button>

            }else{
                return <Button onClick={()=>prevPage()} className='btn-remove-capital' variant="contained" color="primary">Previous page</Button>

            }
        }
    }
    const renderBtnNext=()=>{
        if(active_chunks!==chunks.length-1){
            if(isMobile){
                return <Button style={{minWidth:0,width:8}} onClick={()=>nextPage()} className='btn-remove-capital btn-chevron' variant="contained" color="primary">
                    <img src={ChevronRight} style={{width:15}}/>
                </Button>

            }else{
                return <Button onClick={()=>nextPage()} className='btn-remove-capital' variant="contained" color="primary">Next page</Button>

            }
        }
    }
    const renderTextFlipbook=()=>{
        if(active==0){
            return `1/${data.length}`
        }else{
            if(isMobile){
                return `${active+1}/${data.length}`

            }else{
                return `${active+1}-${active+2}/${data.length}`

            }
        }
    }
    const onClickToc=(index,key)=>{
        setmodal2(false)
        // setactive_toc(key)
        // setactive(index)
        goToPage(index)
    }
    // console.log('trigger')
    return (
        <div>
            <Navbar/>
            <Loading/>
            <Modal  title="Download catalouge" isOpen={modal} children={children()} modalToggle={()=>setmodal(!modal)}/>
            <Modal  title="Table of contents" isOpen={modal2} children={tocModal()} modalToggle={()=>setmodal2(!modal2)}/>
            <br/><br/><br/><br/>
            <animated.div style={tocProps} className={`toc-wrapper `}>
                <div>
                    <div className={`div-flex div-justify-between ${open?'toc-open':'toc-close'}`}>
                        <p className='semi-bold'>Table of contents</p>
                        {open?
                        <CloseIcon color="primary" style={{cursor:'pointer'}} fontSize="small" onClick={()=>toggle()}/>
                        
                        :
                        <MenuIcon color="primary" style={{cursor:'pointer'}} fontSize="small" onClick={()=>toggle()}/>
                        }
                        {/* <p style={{cursor:'pointer'}}onClick={()=>toggle()} >X</p> */}
                    </div>
                </div>
                {open?
                <>
                    {toc.map((data,i)=>(
                        <div className={`toc-content ${active_toc===data.text&&'toc-active'}`} onClick={()=>onClickToc(data.page,data.text)} key={i}>
                            <div className='toc-title'>
                                <p >{data.text}</p>
                            </div>
                        </div>
                    ))}
                    <div style={{padding:'10px 10px 10px 95px'}}>
                        <Button onClick={()=>setmodal(true)} className='btn-remove-capital' variant="contained" color="primary">Download</Button>
                    </div>
                </>
                :<div style={{textAlign:'center',position:'absolute',bottom:10,margin:'auto',width:'100%'}}><img src={CatalogeDownload} style={{width:15,cursor:'pointer'}} onClick={()=>setmodal(true)}/></div>}
            </animated.div>
            
            <div className='catalouge-wrapper '>
                <div className='margin-auto'>
                    <br/>
                    {open||isMobile&&<HeadPage title='E-Cataloge' subtitle='For our valued customer' is_filter={false}/>}
                    <div className='flipbook-wrapper'>
                        <div className='flipbook-number-wrapper'>
                            {isMobile&&<p onClick={()=>setmodal2(true)} style={{color:'#00a1ed',cursor:'pointer',fontWeight:'bold'}}>Table Of Contents</p>}
                            <div className='flipbook-number-container'>
                                <p>{renderTextFlipbook()}</p>
                            </div>
                        </div>
                        {!open&&!isMobile&&
                        <animated.div style={flipbookProps} className='flipbook-container'>
                            
                            <HTMLFlipBook
                                // width={520}
                                // height={380}
                                // maxWidth={620}
                                // size="stretch"
                                width={550}
                                height={410}
                                size="stretch"
                                minWidth={520}
                                maxWidth={1000}
                                minHeight={400}
                                maxHeight={1533}
                                autoSize={true}
                                showCover={true}
                                ref={(el)=>(ref=el)}
                                mobileScrollSupport={true}
                                usePortrait={false}
                                onFlip={(data)=>onFlip(data)}
                                // onChangeState={(data)=>onFlip(data)}
                                startZIndex={2}
                                onInit={(event)=>ref.pageFlip.turnToPage(active)}
                                // changeOrientation={()=>console.log('orientation')}
                            >
                                {data.map((data,i)=>(
                                    <img src={data.img} style={{width:'100%'}}/>
                                ))}
                            </HTMLFlipBook> 
                        
                        </animated.div>
                        }
                        {open&&!isMobile&&
                        <animated.div style={flipbookProps} className='flipbook-container'>
                            
                            <HTMLFlipBook
                                width={435}
                                height={360}
                                autoSize={true}
                                showCover={true}
                                ref={(el)=>(ref=el)}
                                mobileScrollSupport={true}
                                usePortrait={false}
                                onFlip={(data)=>onFlip(data)}
                                onInit={(event)=>ref.pageFlip.turnToPage(active)}
                            >
                                {data.map((data,i)=>(
                                    <img src={data.img} style={{width:'100%'}}/>
                                ))}
                            </HTMLFlipBook> 
                        
                        </animated.div>
                        }
                        {isMobile&&
                            <div style={{width:'100%'}}>
                                <HTMLFlipBook
                                     width={490}
                                     height={400}
                                     size="stretch"
                                     minWidth={300}
                                     maxWidth={490}
                                     minHeight={290}
                                     maxHeight={400}
                                    autoSize={true}
                                    showCover={true}
                                    ref={(el)=>(ref=el)}
                                    mobileScrollSupport={true}
                                    onFlip={(data)=>onFlip(data)}
                                    onInit={(event)=>ref.pageFlip.turnToPage(active)}
                                >
                                    {data.map((data,i)=>(
                                        <img src={data.img} style={{width:'100%'}}/>
                                    ))}
                                </HTMLFlipBook> 
                            </div>
                        }
                        <br/>
                        <animated.div style={flipbookProps} className='flipbook-thumbnail'>
                            {renderBtnPrev()}
                            
                                {chunks[active_chunks].map((data,i)=>(
                                    <img onClick={()=>goToPage(data.page-1)} style={{width:isMobile?45:open?90:100}} src={data.img} alt="catalouge" className={`thumbnail-img ${renderActiveThumb(data.page-1)}`}/>
                                ))}
                            {renderBtnNext()}
                        </animated.div>
                    </div>
                </div>
            </div>
            {isMobile?
                <section className='contacts-mobile'>
                    <div style={{width:'90%',height:'100%',margin:'auto',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                        <h1>How we can help<br/> your organization?</h1>
                        <Button onClick={()=>window.location.assign('/contact')} style={{textTransform:'none'}} variant="contained" size="small" className="contacts-button-mobile">Contact Us</Button>
                
                    </div>
                    {/* <Button style={{textTransform:'none'}} variant="contained" size="small" className="contact-button-mobile">Contact Us</Button> */}
                </section>
            :
            <section className="contact-us">
                <div style={{width:450,marginLeft:'8%'}}>
                    <h1>How we can help your organization?</h1>
                </div>
                <div>
                    <Button style={{textTransform:'none'}} variant="contained" size="large" className="contact-button" onClick={()=>window.location.assign('/contact')}>Contact Us</Button>
                </div>
            </section>}
            <br/>
            <Footer/>
        </div>
    )
}
